import React, {useState} from 'react'
import { Link, useNavigate } from 'react-router-dom';
import {BASE_URL} from './helper'

export default function Signup() {
    const navigate = useNavigate()

    const [credentials, setcredentials] = useState({name:"", email:"", password:"", geolocation:""})

    const handleSubmit = async(e)=>{
        e.preventDefault();
        const response = await fetch(`${BASE_URL}/api/createuser`,{
            method: "POST",
            headers:{
                'Content-Type':'application/json'
            },
            body:JSON.stringify({name:credentials.name, email:credentials.email, password:credentials.password, location:credentials.geolocation})
        });
        const json = await response.json()
        console.log(json);
        if (!json.success) {
            alert("Enter vailed credentials")
        }
        if (json.success) {
            alert("Register Succesfully")
            navigate("/login")
          }
    }

    const onchange=(event)=>{
        setcredentials({...credentials,[event.target.name]:event.target.value})
    }


    return (
        <>
            <div className='container'>
                <form onSubmit={handleSubmit}>
                    <div className="m-3">
                        <label htmlFor="exampleInputName">Name</label>
                        <input type="text" className="form-control" onChange={onchange} placeholder="Enter name" name='name' value={credentials.name} />
                    </div>
                    <div className="m-3">
                        <label htmlFor="exampleInputEmail1">Email address</label>
                        <input type="email" className="form-control" onChange={onchange} placeholder="Enter email" name='email' value={credentials.email} />                    </div>
                    <div className="m-3">
                        <label htmlFor="exampleInputPassword1">Password</label>
                        <input type="password" className="form-control" onChange={onchange} placeholder="Password" name='password' value={credentials.password} />
                    </div>
                    <div className="m-3">
                        <label htmlFor="exampleInputPassword1">Address</label>
                        <input type="text" className="form-control" onChange={onchange} placeholder="Address" name='geolocation' value={credentials.geolocation}/>
                    </div>
                    <button type="submit" className=" m-3 btn btn-primary">Submit</button>
                    <Link className="m-3 btn btn-success" to="/Login">Already a user</Link>
                </form>
            </div>
        </>
    )
}
